export const initialState = {
  fromdb: null,
  offerdb: null,
  offerDetails: [],
  tablePages: 0,
  tableCarsPages: 0,
  isLoading: false,
  successModal: {
    show: false,
    message: null,
  },
  errorModal: {
    show: false,
    message: null,
  },
  error: null,
};
